/**
 * The "active admin" of a group or an organization.
 *
 * Both GET /groups and GET /organizations return this exact shape, so the
 * schema lives here rather than being duplicated per feature.
 * `null` means no active admin is assigned.
 */
import { z } from "zod";

export const activeAdminSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  phone: z.string().nullable().default(""),
});

export type ActiveAdmin = z.infer<typeof activeAdminSchema>;
